import React from 'react';
import './Services.css';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

interface Service {
  id: number;
  image: string;
  title: string;
  description: string;
}

const Services: React.FC = () => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });
  const services: Service[] = [
    {
      id: 1,
      image: '/images/chenyannan1976___源文件(1).png',
      title: '心灵游乐场',
      description: '以艺术心理疗法为载体，通过绘画、音乐、舞动、戏剧、正念等多种形式，为个人和家庭提供专业的心理咨询服务。',
    },
    {
      id: 2,
      image: '/images/未来岛logo.png',
      title: '少年未来岛',
      description: '专注于青少年心理健康教育，通过艺术疗法帮助青少年健康成长，建立积极的心理状态。',
    },
    {
      id: 3,
      image: '/images/lomilola.jpg',
      title: 'LOMILOLA品牌系列',
      description: '研发艺术心理治疗相关的专业产品和工具，为心理咨询师和教育工作者提供专业支持。',
    },
  ];

  return (
    <section id="services" className="services">
      <div className="services-container" ref={ref}>
        <div className={`section-header ${isVisible ? 'visible' : ''}`}>
          <h2 className="section-title">业务分布</h2>
          <p className="section-subtitle">
            全方位的心理健康教育与专业支持服务
          </p>
        </div>

        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <div className="service-image-wrapper">
                <img src={service.image} alt={service.title} className="service-image" />
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
